module.exports = __webpack_public_path__ + "static/media/20ECE23.e3c24d90.jpg";